import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutBreakpoints } from '../../core/util/layout-breakpoints';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {

  extraSmallScreenOrLess$ = LayoutBreakpoints.matches(this.breakpointObserver, LayoutBreakpoints.extraSmallScreenOrLess);
  constructor(private dialogRef: MatDialogRef<ModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private breakpointObserver: BreakpointObserver) {}

  gotoDetailAndClose() {
    !this.data.disableClose && this.dialogRef.close({ goToDetail: true });
  }
  gotoOverviewAndClose() {
    !this.data.disableClose && this.dialogRef.close({ goToOverview: true });
  }
  downloadAndClose() {
    !this.data.disableClose && this.dialogRef.close({ downloadDocument: true, goToDetail: true });
  }
  createAndClose() {
    !this.data.disableClose && this.dialogRef.close({ goToCreate: true });
  }
  copyAndClose() {
    !this.data.disableClose && this.dialogRef.close({ goToCopy: true });
  }
}
